import React from 'react';
import './Banner6.css';

const Banner = () => {
  const handleClick = () => {
    // // Subject and pre-loaded message (ensure proper encoding)
    // const subject = encodeURIComponent('Become a Hot Charge Partner Inquiry');
    // const message = encodeURIComponent('I am interested in becoming a partner with Hot Charge. Please provide more information about your partnership program.');

    // // Securely construct the mailto link (avoid inline encoding)
    // const mailtoLink = `mailto:info@hotcharge.in?subject=${subject}&body=${message}`;
    const openTallyForm = `https://tally.so/r/mYdDxq`;

    // Open the user's default email client with the pre-populated content
    window.open(openTallyForm, '_blank');
  };

  return (
    <div id="b6" className="banner6-div">
      <h1 className="banner6-heading">Empowering Connections, Enhancing Mobility</h1>
      <p className="banner6-description">Join us in revolutionizing mobile connectivity with our innovative power bank rental service. Together, we can power the future.</p>
      <button className="learn-button-banner6" onClick={handleClick}>
        Become a Partner
      </button>
    </div>
  );
};

export default Banner;


// WEBPACK FOOTER //
// ./src/components/Banner6/Banner6.js